import { render } from "./LoadingComponent.vue?vue&type=template&id=6cac09ba&scoped=true"
const script = {}

import "./LoadingComponent.vue?vue&type=style&index=0&id=6cac09ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cac09ba"]])

export default __exports__